import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Searchbar from "../../components/Search";
import useApiGet from "../hooks/getData";
import useApiPost from "../hooks/postData";
import toast from "react-hot-toast";

const inputCls =
  "w-full px-3 py-2 text-sm border rounded-md outline-none font-poppins border-[#E3E3E3] dark:border-[#1F1F1F] dark:bg-primary dark:text-darkText";
const labelCls = "block mb-1 text-sm font-poppins text-[#858585]";

function PostCoinSettings() {
  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);
  const { getData, loading } = useApiGet();
  const { postData } = useApiPost();

  const [form, setForm] = useState({
    coins_per_unit: "",
    rupees_per_unit: "",
    min_withdraw_coins: "",
  });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const res = await getData("/post-coins/admin/settings");
      if (res?.data) setForm(res.data);
    } catch (err) {
      toast.error("Failed to load settings");
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await postData("/post-coins/admin/settings", {
        coins_per_unit: Number(form.coins_per_unit),
        rupees_per_unit: Number(form.rupees_per_unit),
        min_withdraw_coins: Number(form.min_withdraw_coins),
      });
      if (res?.data) setForm(res.data);
      toast.success("Settings saved");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
      <Searchbar />

      <div className="px-4 pb-10 xl:px-6">
        <div className="flex justify-between border-t-[#F2F2F2] py-3">
          <h2 className="text-[#000000] dark:text-darkText font-poppins text-xl font-semibold pt-3">
            Post Coin Settings
          </h2>
        </div>

        <div className="flex items-center gap-2">
          <Link to="/dashboard">
            <h3 className="text-[#3A3A3A] dark:text-darkText font-poppins text-base font-semibold">
              Dashboard
            </h3>
          </Link>
          <div className="rounded-full w-1 h-1 bg-[#E0E0E0]"></div>
          <h3 className="text-[#858585] font-poppins text-base">Post Coin Settings</h3>
        </div>

        <form
          onSubmit={save}
          className="max-w-2xl p-6 mt-8 border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg"
        >
          <p className="mb-4 text-sm font-poppins text-[#858585]">
            What post coins are worth when a user withdraws. Only affects requests made after saving.
          </p>

          <div className="grid gap-4 sm:grid-cols-3">
            <div>
              <label className={labelCls}>Coins per unit</label>
              <input
                type="number"
                min="1"
                required
                value={form.coins_per_unit}
                onChange={set("coins_per_unit")}
                className={inputCls}
              />
            </div>
            <div>
              <label className={labelCls}>Rupees per unit</label>
              <input
                type="number"
                min="0"
                step="0.01"
                required
                value={form.rupees_per_unit}
                onChange={set("rupees_per_unit")}
                className={inputCls}
              />
            </div>
            <div>
              <label className={labelCls}>Min withdraw coins</label>
              <input
                type="number"
                min="1"
                required
                value={form.min_withdraw_coins}
                onChange={set("min_withdraw_coins")}
                className={inputCls}
              />
            </div>
          </div>

          {form.coins_per_unit !== "" && (
            <p className="mt-4 text-sm font-semibold font-poppins dark:text-darkText">
              {form.coins_per_unit} coins = ₹{form.rupees_per_unit}
            </p>
          )}

          <button
            type="submit"
            disabled={saving || loading}
            className="px-6 py-2 mt-6 text-sm text-white rounded-md font-poppins bg-button-gradient disabled:opacity-50"
          >
            {saving ? "Saving..." : "Save Settings"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PostCoinSettings;
